import i18n from "i18next";
import { initReactI18next, UseTranslationOptions } from "react-i18next";
import Backend from "i18next-http-backend";
import { ILanguage } from "../models/company";

const localStorageLangKey = "lang_p";
const localStorageCompanyLangKey = "lang_default";

export const UILanguages: ILanguage[] = [
  { id: 1, name: "Italiano", locale: "it-IT", flagIcon: "flag-icon-it" },
  { id: 2, name: "English", locale: "en-US", flagIcon: "flag-icon-us" },
  { id: 3, name: "Français", locale: "fr-FR", flagIcon: "flag-icon-fr" }, 
];

// export const getDefaultLanguageLocale = () => {
//   return UILanguages[0].locale;
// };

export const formatCustomDate = (inputDate: string | number | Date) => {
  const date = new Date(inputDate);
  const locale = i18n.language;

  const pad = (n: number) => n.toString().padStart(2, "0");

  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1);
  const year = date.getFullYear();
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  // Determina se i secondi sono diversi da zero
  const showSeconds = seconds !== "00";

  switch (locale) {
    case "it-IT":
      return `${day}/${month}/${year} ${hours}:${minutes}${showSeconds ? `:${seconds}` : ""}`;

    case "en-US":
      return date.toLocaleString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: showSeconds ? "2-digit" : undefined,
        hour12: true,
      });
case "fr-FR":
  return `${day}/${month}/${year} ${hours}:${minutes}${showSeconds ? `:${seconds}` : ""}`;
    default:
      return date.toISOString(); // fallback generico
  }
};



export const getDefaultLanguageLocale = () => {
  
  var languageDefault = window.localStorage.getItem(localStorageCompanyLangKey);

 
  // var xx= UILanguages.find((lang) => lang.locale === languageDefault)?.locale || UILanguages[0].locale;
  // console.log("getDefaultLanguageLocale xx", xx);
  return UILanguages.find((lang) => lang.locale === languageDefault)?.locale || UILanguages[0].locale;
 };

   //------- Aggiunto per avere un localstore della lingua della company

   export const setDefaultCompanyLanguage = (language : string) => {
    // rimuove la lingua corrente dal localStorage
    window.localStorage.removeItem(localStorageCompanyLangKey);
    // setta la lingua de fault della company
    const lsLang = window.localStorage.getItem(localStorageCompanyLangKey);
    return lsLang ? lsLang : setLanguageDefault(language);
};

export const setLanguageDefault = async (language: string) => {
  try {
    const lsLang = window.localStorage.getItem(localStorageLangKey);
    // la setto come lingua di default della company solo se non ho quella dll'utente
    if(!lsLang) 
    await i18n.changeLanguage(language);
    window.localStorage.setItem(localStorageCompanyLangKey, language);
  } catch (error) {
    console.log(error);
  }
};

export const changePrincipalLanguage= async (languageId ?: number) => {
  switch (languageId) {
    case 1:
      await seti18nextLanguage("it-IT");
      break;
    case 2:
      await seti18nextLanguage("en-US");
      break;
      case 3:
      await seti18nextLanguage("fr-FR"); 
      break;
    default:
      // Rimuovo il localStorage della lingua
      window.localStorage.removeItem(localStorageLangKey);
      break;
      // await seti18nextLanguage(defaultLanguageCompany);
      // await setDefaultCompanyLanguage(defaultLanguageCompany);
 }

}

//-----------------------------------------

export const getLanguageSelectlanguage = () => {
  const lsLang = window.localStorage.getItem(localStorageLangKey);

  return lsLang ? lsLang : "";
};



export const geti18nextLanguage = () => {
  const lsLang = window.localStorage.getItem(localStorageLangKey);

  return lsLang ? lsLang : getDefaultLanguageLocale();
};

export const seti18nextLanguage = async (locale: string) => {
  try {
    await i18n.changeLanguage(locale);
    window.localStorage.setItem(localStorageLangKey, locale);
  } catch (error) {
    console.log(error);
  }
};

export const getTranslationsPath = () => {
  const isNativeApp = process.env.REACT_APP_IS_NATIVE_APP === "true";
  return `${isNativeApp ? "" : "/player"}/locales/{{lng}}/{{ns}}.json`; //verificare path su server
};



export const getSupportedLanguagesLocale = () => {
  return UILanguages.map((x) => x.locale);
};

export const translationHookOptions: UseTranslationOptions = {
  useSuspense: false,
};

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    //debug: true,
    lng: geti18nextLanguage(),
    supportedLngs: getSupportedLanguagesLocale(),
    fallbackLng: getDefaultLanguageLocale(),
    ns: ["translation", "toast", "guest"],
    defaultNS: "translation",
    backend: {
      loadPath: getTranslationsPath(),
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
